import { Link } from 'react-router-dom';
import phoneHero from '../pics/Gemini_Generated_Image_kqalepkqalepkqal.png';
import './Home.css';

/* ── SVG Icons ─────────────────────────────────────────────── */
const svgProps = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' };

const PhoneIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.81a19.79 19.79 0 01-3.07-8.63A2 2 0 012 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.11 7.3a16 16 0 006.59 6.59l1.36-1.14a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14.92z"/>
  </svg>
);
const ScreenIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <rect x="5" y="2" width="14" height="20" rx="2"/>
    <circle cx="12" cy="17" r="1" fill="currentColor" stroke="none"/>
  </svg>
);
const BatteryIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <rect x="2" y="7" width="16" height="10" rx="2"/>
    <path d="M22 11v2M7 12h4M9 10v4"/>
  </svg>
);
const LightningIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
  </svg>
);
const WaterIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <path d="M12 2c0 0-7 9-7 13a7 7 0 0014 0c0-4-7-13-7-13z"/>
  </svg>
);
const CameraIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/>
    <circle cx="12" cy="13" r="4"/>
  </svg>
);
const GlassIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <rect x="3" y="3" width="18" height="18" rx="3"/>
    <path d="M3 9h18M9 21V9"/>
  </svg>
);
const AwardIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <circle cx="12" cy="8" r="6"/>
    <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
  </svg>
);
const WrenchIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>
  </svg>
);
const ShieldIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);
const LocationIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);
const ClockIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 6v6l4 2"/>
  </svg>
);
const CheckIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}>
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const StarFill = () => (
  <svg width="13" height="13" viewBox="0 0 24 24">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#f59e0b"/>
  </svg>
);

/* ── Data ───────────────────────────────────────────────────── */
const popularRepairs = [
  { icon: <ScreenIcon />, name: 'Screen Repair', time: '30–45 min', from: '$49', desc: 'Cracked or shattered screen? We restore it like new.' },
  { icon: <BatteryIcon />, name: 'Battery Replacement', time: '20–30 min', from: '$39', desc: 'Restore full battery life with a premium replacement.' },
  { icon: <LightningIcon />, name: 'Charging Port Repair', time: '30–60 min', from: '$30', desc: 'Fixes loose, slow, or non-charging ports fast.' },
  { icon: <WaterIcon />, name: 'Water Damage Repair', time: 'Same Day', from: '$49', desc: 'Dropped in water? Bring it in ASAP for the best chance.' },
  { icon: <CameraIcon />, name: 'Camera Repair', time: '30–60 min', from: '$59', desc: 'Blurry, cracked, or dead camera? We fix them all.' },
  { icon: <GlassIcon />, name: 'Back Glass Repair', time: '45–90 min', from: '$69', desc: 'Restore the look of your phone with quality back glass.' },
];

const whyUs = [
  { icon: <LightningIcon />, title: 'Same-Day Repairs', desc: 'Most repairs done in under an hour while you wait.' },
  { icon: <AwardIcon />, title: '16+ Years Experience', desc: 'Trusted technicians with over a decade of hands-on expertise.' },
  { icon: <WrenchIcon />, title: 'Quality Parts', desc: 'We use premium-grade parts that meet or exceed OEM standards.' },
  { icon: <ShieldIcon />, title: 'Repair Warranty', desc: 'All repairs come with a warranty for your peace of mind.' },
];

const reviews = [
  { name: 'Michael T.', rating: 5, text: 'Amazing service! Fixed my cracked iPhone screen in 30 minutes. Looks brand new. Price was very reasonable. Highly recommend!', device: 'iPhone 14 Pro' },
  { name: 'Sarah L.', rating: 5, text: 'Brought in my Samsung with water damage and they worked magic. Phone works perfectly. Very professional and honest shop.', device: 'Samsung Galaxy S22' },
  { name: 'James R.', rating: 5, text: 'Battery was dying so fast. They replaced it same day for a great price. Staff is super friendly and knowledgeable.', device: 'iPhone 13' },
];

export default function Home() {
  return (
    <div className="home">

      {/* ── HERO ── */}
      <section className="home-hero">
        {/* Background layers */}
        <div className="home-hero__grid" />
        <div className="home-hero__glow home-hero__glow--1" />
        <div className="home-hero__glow home-hero__glow--2" />

        <div className="home-hero__container">

          {/* ── Left: Content ── */}
          <div className="home-hero__content">
            <div className="home-hero__badge">
              <span>5.0</span>
              <StarFill />
              <span>(1,000+ Verified Google Reviews)</span>
            </div>

            <h1 className="home-hero__title">
              Expert Phone<br />Repair. Same Day.

            </h1>

            <p className="home-hero__sub">
              Huber Heights' most trusted repair shop — 16+ years of experience,
              premium parts, and the best prices in town.
            </p>

            <div className="home-hero__actions">
              <a href="tel:9372350298" className="home-hero__btn home-hero__btn--primary">
                <PhoneIcon size={16} /> Call Now
              </a>
              <Link to="/quote" className="home-hero__btn home-hero__btn--secondary">
                Book Appointment
              </Link>
            </div>

            <div className="home-hero__trust-row">
              <div className="home-hero__trust-item"><ShieldIcon size={14}/><span>Warranty Included</span></div>
              <div className="home-hero__trust-dot"/>
              <div className="home-hero__trust-item"><ClockIcon size={14}/><span>Same-Day Service</span></div>
              <div className="home-hero__trust-dot"/>
              <div className="home-hero__trust-item"><AwardIcon size={14}/><span>16+ Years Exp.</span></div>
            </div>
          </div>

          {/* ── Right: Animated phone ── */}
          <div className="home-hero__visual">

            {/* Floating badges */}
            <div className="home-hero__badge-float home-hero__badge-float--1">
              <ClockIcon size={12}/> 30 Min Repair
            </div>
            <div className="home-hero__badge-float home-hero__badge-float--2">
              <ShieldIcon size={12}/> Warranty Included
            </div>

            {/* Phone scene */}
            <div className="home-hero__scene">
              <img src={phoneHero} alt="Phone repair" className="home-hero__img" />

              {/* Repair status cards */}
              <div className="home-hero__cards">
                <div className="home-hero__card home-hero__card--1">
                  <span className="home-hero__card-icon home-hero__card-icon--green"><CheckIcon size={11}/></span>
                  <span className="home-hero__card-text">Screen Restored</span>
                </div>
                <div className="home-hero__card home-hero__card--2">
                  <span className="home-hero__card-icon home-hero__card-icon--blue"><BatteryIcon size={11}/></span>
                  <span className="home-hero__card-text">Battery at 100%</span>
                </div>
                <div className="home-hero__card home-hero__card--3">
                  <span className="home-hero__card-icon home-hero__card-icon--purple"><ShieldIcon size={11}/></span>
                  <span className="home-hero__card-text">Warranty Active</span>
                </div>
                <div className="home-hero__card home-hero__card--4">
                  <span className="home-hero__card-icon home-hero__card-icon--orange"><LightningIcon size={11}/></span>
                  <span className="home-hero__card-text">Fixed in 30 Min</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── TRUST BAR ── */}
      <section className="home-trust">
        <div className="home-trust__container">
          <div className="home-trust__item">
            <span className="home-trust__icon"><LocationIcon size={18} /></span>
            <div>
              <strong>Huber Heights, OH</strong>
              <span>8239 Troy Pike · Next to Marshall's</span>
            </div>
          </div>
          <div className="home-trust__divider" />
          <div className="home-trust__item">
            <span className="home-trust__icon"><LightningIcon size={18} /></span>
            <div>
              <strong>Same-Day Repairs</strong>
              <span>Most fixes done in under 1 hour</span>
            </div>
          </div>
          <div className="home-trust__divider" />
          <div className="home-trust__item">
            <span className="home-trust__icon"><AwardIcon size={18} /></span>
            <div>
              <strong>16+ Years Experience</strong>
              <span>Trusted by thousands of customers</span>
            </div>
          </div>
          <div className="home-trust__divider" />
          <div className="home-trust__item">
            <span className="home-trust__icon"><PhoneIcon size={18} /></span>
            <div>
              <strong>(937) 235-0298</strong>
              <span>Mon–Sat 10AM–7PM · Sun 12–4PM</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── POPULAR REPAIRS ── */}
      <section className="home-repairs">
        <div className="home-repairs__container">
          <div className="home-repairs__header">
            <span className="home-section-tag">What We Fix</span>
            <h2 className="home-section-title">Most Popular Repairs</h2>
            <p className="home-section-sub">Fast, affordable, and done right the first time. Most repairs completed same day.</p>
          </div>
          <div className="home-repairs__grid">
            {popularRepairs.map((r, i) => (
              <div className="home-repair-card" key={i}>
                <div className="home-repair-card__icon">{r.icon}</div>
                <div className="home-repair-card__body">
                  <h3 className="home-repair-card__name">{r.name}</h3>
                  <p className="home-repair-card__desc">{r.desc}</p>
                  <div className="home-repair-card__footer">
                    <div className="home-repair-card__meta">
                      <span className="home-repair-card__time">{r.time}</span>
                      <span className="home-repair-card__price">From {r.from}</span>
                    </div>
                    <Link to="/quote" className="home-repair-card__cta">Quote →</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="home-repairs__footer">
            <Link to="/services" className="home-repairs__all-btn">View All Services →</Link>
          </div>
        </div>
      </section>

      {/* ── WHY US ── */}
      <section className="home-why">
        <div className="home-why__container">
          <div className="home-why__header">
            <span className="home-section-tag home-section-tag--light">Why Choose Us</span>
            <h2 className="home-section-title home-section-title--light">The Fix'n More Difference</h2>
            <p className="home-section-sub home-section-sub--light">We've been fixing phones since before smartphones were smart.</p>
          </div>
          <div className="home-why__grid">
            {whyUs.map((w, i) => (
              <div className="home-why__card" key={i}>
                <div className="home-why__card-icon">{w.icon}</div>
                <h3 className="home-why__card-title">{w.title}</h3>
                <p className="home-why__card-desc">{w.desc}</p>
              </div>
            ))}
          </div>
          <div className="home-why__cta">
            <Link to="/about" className="home-why__learn">Learn More About Us →</Link>
          </div>
        </div>
      </section>

      {/* ── REVIEWS ── */}
      <section className="home-reviews">
        <div className="home-reviews__container">
          <div className="home-reviews__header">
            <span className="home-section-tag">Customer Reviews</span>
            <h2 className="home-section-title">What Our Customers Say</h2>
            <div className="home-reviews__score">
              <span className="home-reviews__score-num">5.0</span>
              <div>
                <div className="home-reviews__stars">
                  {[1,2,3,4,5].map(i => <StarFill key={i} />)}
                </div>
                <span className="home-reviews__count">Based on 1,000+ Google Reviews</span>
              </div>
            </div>
          </div>
          <div className="home-reviews__grid">
            {reviews.map((r, i) => (
              <div className="home-review-card" key={i}>
                <div className="home-review-card__top">
                  <div className="home-review-card__avatar">{r.name[0]}</div>
                  <div>
                    <div className="home-review-card__name">{r.name}</div>
                    <div className="home-review-card__stars">
                      {[...Array(r.rating)].map((_, j) => <StarFill key={j} />)}
                    </div>
                  </div>
                  <div className="home-review-card__g">G</div>
                </div>
                <p className="home-review-card__text">"{r.text}"</p>
                <div className="home-review-card__device">{r.device}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
